var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1055 12.5557C5.29007 12.7578 5.58011 12.749 5.77347 12.5381C7.94437 10.2441 10.8008 9.03125 13.9912 9.03125C17.208 9.03125 20.0733 10.2441 22.2354 12.5557C22.42 12.7402 22.7012 12.7314 22.8858 12.5381L24.1162 11.2988C24.292 11.123 24.292 10.8945 24.1514 10.7275C22.0332 8.11719 18.0869 6.24512 13.9912 6.24512C9.90433 6.24512 5.94925 8.1084 3.83987 10.7275C3.69925 10.8945 3.69925 11.123 3.86624 11.2988L5.1055 12.5557ZM8.77933 16.2119C8.99026 16.4141 9.27151 16.3965 9.47366 16.1768C10.5459 15.0078 12.2598 14.1816 14 14.1904C15.7491 14.1816 17.4629 15.0254 18.5616 16.2031C18.7461 16.4141 19.0098 16.4053 19.2119 16.2031L20.5918 14.8496C20.7588 14.6914 20.7764 14.4717 20.627 14.2959C19.2559 12.6348 16.751 11.4395 14 11.4395C11.2403 11.4395 8.73538 12.6348 7.36429 14.2959C7.21487 14.4717 7.23245 14.6826 7.39944 14.8496L8.77933 16.2119ZM14 21.0811C14.211 21.0811 14.3955 20.9844 14.7559 20.6416L16.9092 18.5674C17.0674 18.418 17.1026 18.1719 16.9619 17.9961C16.3467 17.2139 15.2305 16.5811 14 16.5811C12.7344 16.5811 11.6006 17.2402 10.9942 18.0664C10.8887 18.2246 10.9414 18.418 11.0908 18.5674L13.2442 20.6416C13.5957 20.9756 13.7891 21.0811 14 21.0811Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.81966bdf5c490c48bb311ff056f7ddf8.svg";
export { ForwardRef as ReactComponent };